import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Footer from "./Comps/HEADERandFOOTER/Footer";
import Navbar from "./Comps/HEADERandFOOTER/Navbar";

import Login from "./PAGE/LogIn";
import PrivateRoute from "./Comps/PrivateRoute";
import { Toaster } from "react-hot-toast";
import { useGlobalContext } from "./Comps/Context/GlobalContext";
import ShowToastMsg from "./Comps/Extra/ShowToastMsg";

import { appRoutes } from "./routes";
function App() {
  const { userData } = useGlobalContext();
  // const environment = process.env.REACT_ENVIRONMENT;
  useEffect(() => {
    if (process.env.NODE_ENV === "development") return;

    // Disable right-click
    const handleContextMenu = (e) => {
      e.preventDefault();
    };

    // Block key combos
    const handleKeyDown = (e) => {
      const key = e?.key?.toUpperCase();
      if (
        key === "F12" ||
        (e.ctrlKey && e.shiftKey && ["I", "C", "J"].includes(key)) ||
        (e.ctrlKey && key === "U")
      ) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    };

    // Attach listeners
    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("keydown", handleKeyDown);

    // Cleanup on unmount
    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);
  useEffect(() => {
    if (userData) {
      ShowToastMsg({
        type: "success",
        toastText: `Welcome ${userData.loginThroughToken ? "back" : ""}! ${
          userData.username
        }`,
        duration: 4000,
      });
    }
  }, [userData]);
  return (
    <Router>
      {userData && <Navbar />}
      <Routes>
        <Route path="/LogIn" element={<Login />} />

        {appRoutes.map(({ path, component: Component, roles, permission }) => {
          return (
            <Route
              key={path}
              path={path}
              element={
                <PrivateRoute
                  element={<Component />}
                  allowedRoles={roles}
                  {...(permission && {
                    requiredPermission: permission,
                  })}
                />
              }
            />
          );
        })}
      </Routes>
      {userData && <Footer />}

      <Toaster />
    </Router>
  );
}

export default App;
